import React from "react";
import Card from "./CategoryProductCard";

function CategoryProductRow(){
    return(
        <div className="row my-4">
            <div className="col-4">
                <Card price="200ETH" image_link="https://img.freepik.com/free-vector/hand-drawn-nft-style-ape-illustration_23-2149622021.jpg?w=2000"/>
            </div>
            <div className="col-4">
                <Card price="20.5ETH" image_link="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4NPu__x731dgnjLLmeLfHXGllv5srAEPnvRcQikFXLm6oyBHwSXH0RQtwjFnIBjlTVcc&usqp=CAU"/>
            </div>
            <div className="col-4">
                <Card price="30.10ETH" image_link="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAqiwTgQ8HxiaGAa43dgZ-nbCXHLdtOJywjCeodc663pcGYGAp-Q_RW8e9Kzf8SMP7x3s&usqp=CAU"/>
            </div>
        </div>
    )
}

export default CategoryProductRow;